<template>
  <div>
    <NBar title="批量选择" :top="true"/>
    <div class="top-div">
      <span class="text">您可以批量设置多个场地,也可以在下方逐个设置</span>
      <nut-button type="actived" small @click="cancel()">取消批量</nut-button>
    </div>
    <nut-infiniteloading @loadmore="onInfinite" :is-show-mod="true" :has-more="isHasMore" :is-loading="isLoading"
                         :threshold="200">
      <nut-cell v-for="(item,index) in list" :key="index" :show-icon="true" class="diy-cell">
        <template v-if="type == 1">
          <span slot="title">
            <nut-checkbox
              :disabled='item.deviceAddressSystemSetEntity != null && item.deviceAddressSystemSetEntity.serviceName != null ? true : false'
              v-model="item.checked"/>{{item.name}}
          </span>
          <span slot="desc">{{item.serviceName}}</span>
        </template>
        <template v-if="type == 2">
          <span slot="title">
            <nut-checkbox
              :disabled='item.deviceAddressSystemSetEntity != null && item.deviceAddressSystemSetEntity.phone != null ? true : false'
              v-model="item.checked"/>{{item.name}}
          </span>
          <span slot="desc">{{item.serviceName}}</span>
        </template>
        <template v-if="type == 3">
          <span slot="title">
            <nut-checkbox
              :disabled='item.deviceAddressSystemSetEntity != null && item.deviceAddressSystemSetEntity.startTitle != null ? true : false'
              v-model="item.checked"/>{{item.name}}
          </span>
          <span slot="desc">{{item.serviceName}}</span>
        </template>
        <template v-if="type == 4">
          <span slot="title">
            <nut-checkbox
              :disabled='item.deviceAddressSystemSetEntity != null && item.deviceAddressSystemSetEntity.startMsg != null ? true : false'
              v-model="item.checked"/>{{item.name}}
          </span>
          <span slot="desc">{{item.serviceName}}</span>
        </template>
      </nut-cell>
    </nut-infiniteloading>
    <div class="bottom">
      <nut-checkbox v-model='isAll' @change="checkAll" style="margin-left: 15px;">全选</nut-checkbox>
      <nut-button block style="margin-top: 10px" @click="goSet()">下一步</nut-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BatchSelectAddress',
  props: ['type'],
  data () {
    return {
      list: [],
      isAll: false,
      page: 1,
      limit: 10,
      isHasMore: true,
      isLoading: false,
      isErr: false,
      timer: null,
    }
  },
  mounted () {
    this.user = this.$api.user
    if (this.type != null) {
      let type = this.type
      this.type = type
      this.onInfinite()
    }
  },
  methods: {
    onInfinite () {
      this.isLoading = true
      this.timer = setTimeout(() => {
        this.$api.post({
          url: '/device/api/device/address/list',
          data: {
            merId: this.user.merId,
            storeId: this.user.storeId,
            page: this.page,
            limit: this.limit
          },
        }).then(res => {
          let list = res.data
          this.totalCounts = res.count
          if (this.page > 1 && list.length > 0) {
            for (let i in list) {
              this.list.push(list[i])
            }
          } else {
            this.list = list
          }
          if (this.list.length >= this.totalCounts) {
            this.isHasMore = false
          } else {
            this.page = this.page + 1
          }
        })
        this.isLoading = false
      }, 100)
    },
    checkAll () {
      let i
      let list = this.list
      if (!this.isAll) {
        for (i in list) {
          //客服微信
          if (this.type == 1 && !this.$util.isArrOrNull(list[i].deviceAddressSystemSetEntity) && !this.$util.isArrOrNull(list[i].deviceAddressSystemSetEntity.serviceName)) {
            continue
          }
          //客服电话
          if (this.type == 2 && !this.$util.isArrOrNull(list[i].deviceAddressSystemSetEntity) && !this.$util.isArrOrNull(list[i].deviceAddressSystemSetEntity.phone)) {
            continue
          }
          //页面标题
          if (this.type == 3 && !this.$util.isArrOrNull(list[i].deviceAddressSystemSetEntity) && !this.$util.isArrOrNull(list[i].deviceAddressSystemSetEntity.startTitle)) {
            continue
          }
          //启动页消息
          if (this.type == 3 && !this.$util.isArrOrNull(list[i].deviceAddressSystemSetEntity) && !this.$util.isArrOrNull(list[i].deviceAddressSystemSetEntity.startMsg)) {
            continue
          }
          list[i].checked = false
        }
      } else {
        for (i in list) {
          //客服微信
          if (this.type == 1 && !this.$util.isArrOrNull(list[i].deviceAddressSystemSetEntity) && !this.$util.isArrOrNull(list[i].deviceAddressSystemSetEntity.serviceName)) {
            continue
          }
          //客服电话
          if (this.type == 2 && !this.$util.isArrOrNull(list[i].deviceAddressSystemSetEntity) && !this.$util.isArrOrNull(list[i].deviceAddressSystemSetEntity.phone)) {
            continue
          }
          //页面标题
          if (this.type == 3 && !this.$util.isArrOrNull(list[i].deviceAddressSystemSetEntity) && !this.$util.isArrOrNull(list[i].deviceAddressSystemSetEntity.startTitle)) {
            continue
          }
          //启动页消息
          if (this.type == 3 && !this.$util.isArrOrNull(list[i].deviceAddressSystemSetEntity) && !this.$util.isArrOrNull(list[i].deviceAddressSystemSetEntity.startMsg)) {
            continue
          }
          list[i].checked = true
        }
      }
    },
    cancel () {
      this.$router.go(-1)
    },
    goSet () {
      let data = []
      this.list.forEach(item => {

        if (item.checked) {
          data.push(item)
        }
      })
      if (!this.$util.isArrOrNull(data)) {
        if (this.type == 1) {
          this.$router.push({
            path: '/device/WeChatSet',
            query: {
              type: this.type,
              data: encodeURIComponent(JSON.stringify(data))
            }
          })
        }
        if (this.type == 2) {
          this.$router.push({
            path: '/device/PhoneSet',
            query: {
              type: this.type,
              data: encodeURIComponent(JSON.stringify(data))
            }
          })
        }
        if (this.type == 3) {
          this.$router.push({
            path: '/device/TitleSet',
            query: {
              type: this.type,
              data: encodeURIComponent(JSON.stringify(data))
            }
          })
        }
        if (this.type == 4) {
          this.$router.push({
            path: '/device/MsgSet',
            query: {
              type: this.type,
              data: encodeURIComponent(JSON.stringify(data))
            }
          })
        }
      } else {
        this.$toast.warn('未选中任何数据!')
      }
    }
  }
}
</script>

<style scoped>
  .top-div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
  }

  .top-div .text {
    color: #666;
  }

  .bottom {
    position: fixed;
    bottom: 0;
    background: #fff;
    width: 100%;
    padding-top: 15px;
  }

  >>> .nut-button {
    background: #409EFF;
  }

  >>> .nut-button.actived {
    background: none;
    color: #409EFF;
    border: 1px solid #409EFF;
    border-radius: 5px;
  }

  >>> .nut-checkbox input:checked {
    background-color: #409EFF;
    border-color: #409EFF;
    border-radius: 50%;
  }

  >>> .nut-checkbox.nut-checkbox-size-base input {
    border-radius: 50%;
  }

  >>> .nut-checkbox input:after {
    background: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/BatchSelectAddress.vue